import { Container, Grid, Typography, Box, Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { Link } from 'react-router-dom';

import CarouselMulti from "react-multi-carousel";
import SalesforceLogo from "../../../asset/images/salesforce/salesforce-logo.webp";
import salesforce_banner from "../../../asset/images/salesforce/salesforce_banner.webp";
import Simplifycomplex from "../../../asset/images/salesforce/simplifycomplex_banner.webp";

export default function SalesforceBanner() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    // Scroll to form started
    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const stickyItemsHeight = 30;
            const offset = element.getBoundingClientRect().top - stickyItemsHeight;


            setTimeout(() => {
                window.scrollBy({ top: offset, behavior: 'smooth' });
            }, 50);
        }
    };

    useEffect(() => {
        const { hash } = window.location;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                const offset = 50;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition - offset;
                window.scrollBy({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    }, []);
    // Scroll to form ended 

    return (
        <>
            <Box id="new_landing_carousel">
                <CarouselMulti
                    responsive={responsive}
                    arrows={false}
                    swipeable={true}
                    draggable={true}
                    showDots={true}
                    infinite={true}
                    autoPlay={true}
                    pauseOnHover={false}
                    keyBoardControl={true}
                    customTransition="opacity 200ms ease-in-out"
                    autoPlaySpeed={9500}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-0-px"
                >
                    <>
                        <Box id="salesforce">
                            <Box id="new_landing_carousel" className=''>
                                <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + salesforce_banner + ")" }} pb={2}>
                                    <Container maxWidth="lg">
                                        <Grid container spacing={1} alignItems="center" justifyContent='center'>
                                            <Grid item lg={7} md={9} sm={11} xs={10}>
                                                <Box className="text_animated mb0">
                                                    <Box className='salesimg' mt={3}>
                                                        <img loading="lazy" src={SalesforceLogo} alt="Salesforce logo" />
                                                    </Box>
                                                    <Typography variant="h1" className="white fw6 mb0 h1h1" gutterBottom>
                                                        Elevate Customer Experience <span className='lower'>with</span> Intelligent<span className='white'><span className=''> Salesforce CRM Solutions</span> </span>
                                                    </Typography>

                                                    <Box>
                                                        <Typography variant="h2" className="fw4 white" gutterBottom>
                                                            Drive <span className='lower'>engagement and retention with a customer-first approach.</span>
                                                        </Typography>
                                                    </Box>

                                                    <Box mt={2}>
                                                        <Link to="/salesforce-crm-solutions#salesforce_contactus" onClick={() => scrollToElement('salesforce_contactus')}>
                                                            <Button variant="contained" className='dpabtn_sm1'>
                                                                Get Expert Support
                                                            </Button>
                                                        </Link>
                                                    </Box>

                                                </Box>
                                            </Grid>

                                        </Grid>
                                    </Container>
                                </Box>
                            </Box>
                        </Box>
                    </>

                    <>
                        <Box id="salesforce">
                            <Box id="new_landing_carousel" className=''>
                                <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + Simplifycomplex + ")" }} pb={2}>
                                    <Container maxWidth="lg">
                                        <Grid container spacing={1} alignItems="center" justifyContent='center'>
                                            <Grid item lg={7} md={9} sm={11} xs={10}>
                                                <Box className="text_animated mb0">
                                                    <Box className='salesimg' mt={3}>
                                                        <img loading="lazy" src={SalesforceLogo} alt="Salesforce logo" />
                                                    </Box>
                                                    <Typography variant="h1" className="white fw6 mb0 h1h1" gutterBottom>
                                                    Simplify Complex Processes <span className='lower'>with</span> Smart Salesforce Automation
                                                    </Typography>

                                                    <Box>
                                                        <Typography variant="h2" className="fw4 white" gutterBottom>
                                                            &nbsp;
                                                        </Typography>
                                                    </Box>

                                                    <Box mt={2}>
                                                        <Link to="/case-studies/salesforce-automation-to-simplify-your-complex-processes">
                                                            <Button variant="contained" className='dpabtn_sm1'>
                                                                Explore How
                                                            </Button>
                                                        </Link>
                                                    </Box>

                                                </Box>
                                            </Grid>

                                        </Grid>
                                    </Container>
                                </Box>
                            </Box>
                        </Box>
                    </>
                    
                </CarouselMulti>
            </Box>
        </>
    );
}
